import { Component } from "react";
import Box from '@mui/material/Box';
import ProfileHeader from "../../../components/ProfileHeader";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import { getSessionStorage } from "../../../utils/StorageUtil";
import { COMPANY_ID_SO_KEY, USER_ID_SO_KEY } from "../../../utils/accountUtils";
import CompanyApi from "../../../api/CompanyApi";
import UserDataApi from "../../../api/UserDataApi";
import AvatarCard from "./AvatarCard";
import CompanyCard from "./CompanyCard";
import UserDataCard from "./UserDataCard";
import ProfileContext from "./ProfileContext";

type Props = {};

type State = {
  timesChanged: number
}

export default class extends Component<Props, State> {

  constructor(props: Props) {
    super(props)
    this.state = { timesChanged: 0 }
  }

  render() {
    return (
      <ProfileContext.Consumer>
        { context => {
          context.refresh = () =>
            Promise.all([
              UserDataApi.get(getSessionStorage(USER_ID_SO_KEY)),
              CompanyApi.get(getSessionStorage(COMPANY_ID_SO_KEY))
            ])
            .then((it: any) => {
              context.userData = it[0].data
              context.company = it[1].data
              context.dialogOpen = false
              context.editing = false
              this.setState({ timesChanged: this.state.timesChanged+1 })
            })

          context.update = (value: any): Promise<any> => 
            UserDataApi.patch(getSessionStorage(USER_ID_SO_KEY), value)
            .then(() => context.refresh() )
          
          context.setEditing = (editing: boolean) => {
            context.editing = editing
            this.setState({ timesChanged: this.state.timesChanged+1 })
          }
          
          context.setDialogOpen = (dialogOpen: boolean) => {
            context.dialogOpen = dialogOpen
            this.setState({ timesChanged: this.state.timesChanged+1 })
          }

          if (!context.userData.id) {
            context.refresh()
          }

          return (
            <Box sx={{background: {xs: 'linear-gradient(#5EB07F 100px, #F2F3F1 155px)', sm: '#F2F3F1'}, backgroundAttachment: 'fixed'}}>
              <ProfileHeader selectedOptionIndex={0}></ProfileHeader>
                {(!!context.userData.id) && (
                  <Box sx={{margin: '0 8.5%'}}>
                    <AvatarCard></AvatarCard>
                    {context.company?.id &&  (<CompanyCard></CompanyCard>)} 
                    <UserDataCard></UserDataCard>
                  </Box>
                )}
              <ProfileBottomNav goBack={true}></ProfileBottomNav>
            </Box>
          )
        }}
      </ProfileContext.Consumer>
    );
  }
}